export const EMPTY_PAGINATION = Object.freeze({
  total: 0,
  page: 1,
  pages: 0,
  limit: 20,
});

export const EMPTY_STATUS_SUMMARY = Object.freeze({
  pending: 0,
  done: 0,
  failed: 0,
});

export const isPlainObject = (value) => (
  typeof value === 'object' && value !== null && !Array.isArray(value)
);

export const ensureArray = (value) => (Array.isArray(value) ? value : []);

export const ensureObject = (value, fallback = {}) => (isPlainObject(value) ? value : fallback);

export const ensureNullableObject = (value) => (isPlainObject(value) ? value : null);

const isUserObject = (value) => (
  isPlainObject(value)
  && typeof value.role === 'string'
  && (
    typeof value.email === 'string'
    || typeof value.name === 'string'
    || typeof value.id === 'string'
  )
);

export const ensureUserPayload = (value) => {
  const payload = ensureObject(value);
  const user = ensureNullableObject(payload.user);

  if (user) {
    return {
      ...payload,
      user,
    };
  }

  if (isUserObject(payload)) {
    return {
      user: payload,
    };
  }

  return {
    ...payload,
    user: null,
  };
};

export const ensurePaginatedResult = (value) => {
  const payload = ensureObject(value);
  const summary = ensureObject(payload.summary);

  return {
    ...payload,
    data: ensureArray(payload.data),
    pagination: ensureObject(payload.pagination, EMPTY_PAGINATION),
    summary: {
      ...summary,
      statusCounts: ensureObject(summary.statusCounts, EMPTY_STATUS_SUMMARY),
    },
  };
};

export const ensureBulkResult = (value) => {
  const payload = ensureObject(value);

  return {
    requestedCount: Number(payload.requestedCount) || 0,
    createdCount: Number(payload.createdCount) || 0,
    successItems: ensureArray(payload.successItems),
    failedItems: ensureArray(payload.failedItems),
    rolledBack: Boolean(payload.rolledBack),
  };
};

export const ensureProjectPayload = (value) => (
  isPlainObject(value) && value._id ? value : null
);
